import PhotosGallery from './PhotosGallery';

export default PhotosGallery;
